const getButtonFocusOverrideStyle = outlineColor => ({
  outline: `1px solid ${outlineColor}`,
  outlineOffset: -1,
  '&:after': {
    border: 0,
  },
});

export const getToggleMenuItemStyles = (toggleMenuItem, { palette = {} }) => ({
  toggleMenuItemContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  toggleButton: {
    height: 24,
    width: 24,
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    fontFamily: 'Segoe UI',
    fontSize: 14,
    display: 'inline-block',
    background: '#2F2F2F !important',
    '&:focus': getButtonFocusOverrideStyle(palette.neutralSecondary),
    '&:hover': {
      backgroundColor: `${palette.mainMenuHoverBackground} !important`,
    },
    marginTop: 18,
    marginLeft: 12,
  },
  toggleTextDiv: {
    height: 44,
    fontFamily: 'Segoe UI',
    fontSize: 14,
    display: 'inline-block',
  },
  toggleTextContainer: {
    display: 'inline-block',
    marginTop: 12,
    marginBottom: 14.42,
    marginLeft: 13,
    fontSize: 13.58,
  },
  toggleIcon: {
    color: palette.white,
  },
  rightmostDivider: {
    alignSelf: 'center',
    width: '1px',
    height: '32px',
    background: palette.mainMenuHoverBackground,
    position: 'absolute',
    right: 0,
  },
});
